var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.844 10.219a.666.666 0 0 0 .889.314 3.8 3.8 0 0 0 1.058-.752 3.814 3.814 0 0 0 0-5.387L7.857 2.46a3.815 3.815 0 0 0-5.395.01 3.813 3.813 0 0 0 0 5.386l.827.828a.667.667 0 1 0 .943-.944l-.827-.827a2.48 2.48 0 0 1 .009-3.51 2.48 2.48 0 0 1 3.501 0l1.933 1.933a2.482 2.482 0 0 1-.69 3.994.666.666 0 0 0-.314.889m.3 3.32a3.815 3.815 0 0 0 5.396-5.396l-.828-.827a.667.667 0 1 0-.943.943l.828.828a2.48 2.48 0 0 1-.01 3.51 2.48 2.48 0 0 1-3.5 0l-1.934-1.933a2.482 2.482 0 0 1 .69-3.994.666.666 0 1 0-.574-1.204 3.8 3.8 0 0 0-1.058.753 3.814 3.814 0 0 0 0 5.387z",
    clipRule: "evenodd"
  })));
};
export default SvgLink;